import React, { Component } from 'react';

import Blocks from './parts/companies/Blocks';
import ButtonChoose from '../components/ButtonChoose';
import Clients from '../components/Clients';
import ContactButton from '../components/contact/ContactButton';
import Content from './parts/companies/Content';
import QuoteBar from '../components/QuoteBar';
import Slider from '../components/Slider';
import Strategy from './parts/companies/Strategy';
import Technology from './parts/companies/Technology';

import backgroundImage from '../resources/img/slider-bg-pic4.jpg';

export default class Companies extends Component {
    constructor(props) {
        super(props);

        this.pageTitle = 'Companies';
        this.textLeft = (
            <h2>
                Business Transformation and<br />
                Executive Development go hand-in-hand.<br />
                Would better video content deliver more result?
            </h2>
        );
        this.textRight = (
            <span>{this.pageTitle.toUpperCase()}</span>
        );
        this.buttons = [
            {
                to: "portfolio",
                className: "btn-portfolio",
                text: "More examples"
            }, {
                to: "contact",
                className: "",
                text: "Contact us"
            }
        ];
    }

    render() {
        document.title = 'TROI Studio | '+ this.pageTitle;

        return (
            <div>
                <ContactButton />

                <Slider backgroundImage={backgroundImage}
                    textLeft={this.textLeft}
                    textRight={this.textRight} />
                <QuoteBar text="" />

                <Blocks />

                <Strategy />
                <Content />
                <Technology />

                <ButtonChoose buttons={this.buttons} />

                <Clients />
            </div>
       );
    }
}



// WEBPACK FOOTER //
// ./src/pages/Companies.js